import { Container } from '@mui/material';
import React, { Component, useState } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';

class Registro extends Component {
    constructor(props){
        super(props);
        this.state = {

            notificaciones: null,
            errores: null,
            numeroNombre: [],

            registro: {
                numeroFuncionario: '',
                password: '',
                nombreFuncionario: '',
                tipoUsuario: '2',
            }
        }
        this.controlarCambios = this.controlarCambios.bind(this);
        this.manejarEnvioDatos = this.manejarEnvioDatos.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }

    render(){
        return (
            <>
                <Container>
                    {sessionStorage.login && sessionStorage.tipoUsuario === '1'
                    ?
                        <div className='mt-5'>
                            <h3 className='text-center'>REGISTRO</h3>
                            <hr />
                            <div className='row justify-content-center'>
                                <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                                    <form onSubmit={this.manejarEnvioDatos}>
                                        <p>(1- Admin, 2- Fun. Normal, 3- Jefes de Sección, 4- Funcionario Personal, 5- Usuario Final, 6- Salario Vacacional, 7- Tribunal)</p>
                                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                        <input type="text" className='form-control mb-2'  placeholder='INGRESE USUARIO' id='numeroFuncionario' onChange={this.controlarCambios} value={this.state.registro.numeroFuncionario}/>
                                        <input type="password" className='form-control mb-2' placeholder='INGRESE PASSWORD' id='password' onChange={this.controlarCambios} value={this.state.registro.password}/>
                                        <input type="text" className='form-control mb-2' placeholder='INGRESE PASSWORD' id='tipoUsuario' onChange={this.controlarCambios} value={this.state.registro.tipoUsuario}/>
                                        <button className='btn btn-outline-dark btn-lg btn-block'>Registrar</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    :
                        <Redirect to='/inicio'/>
                    }
                </Container>
            </>
        )//Final return
    }//Final render

    controlarCambios(e){
        e.preventDefault()
        
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const registroActualizado = state.registro;
            registroActualizado[clave] = valor;
            /*if((clave === 'numeroFuncionario') && (valor !== '')){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    registroActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    registroActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'numeroFuncionario') && (valor === '')){
                registroActualizado['nombreFuncionario'] = '';
            }*/
            
            return{
                registro: registroActualizado,
            };
        })
    }

    async manejarEnvioDatos(e){
        e.preventDefault()
        if(this.state.registro.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un numero de funcionario!'
            });
        }/*else if(this.state.registro.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un numero de funcionario valido!'
            });
        }*/else if(this.state.registro.password === ''){
            this.setState({
                errores: 'Debe ingresar una contraseña!'
            });
        }else{
            const cargaUtil = JSON.stringify(this.state.registro);

            const respuesta = await fetch(`${Constantes.RUTA_API}/registrar_usuario.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito.length !== 0){
                this.setState({
                    notificaciones: 'Todo bien',
                    registro: {
                        numeroFuncionario: '',
                        password: '',
                        nombreFuncionario: '',
                        tipoUsuario: '2',
                    }
                })
            }else{
                this.setState({
                    errores: 'Ya existe un usuario',
                })
            }
        }
    }
}

export default Registro